module.exports = __webpack_public_path__ + "static/Tempest-39d6ecdb0dba1bb9645cbea7f85ab59b.jpg";